// Utility functions for PWA installation

// Variable to store the deferred prompt event
let deferredPrompt = null;

// Check if the app is running as a PWA
export const isRunningAsPwa = () => {
  return window.matchMedia('(display-mode: standalone)').matches || 
         window.navigator.standalone || 
         document.referrer.includes('android-app://');
};

// Check if the browser supports PWA installation
export const isPwaInstallable = () => {
  return !!deferredPrompt;
};

// Set up event listener for beforeinstallprompt
export const setupPwaInstallListener = () => {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Store the event so it can be triggered later
    deferredPrompt = e;
  });
};

// Show the PWA installation prompt
export const showPwaInstallPrompt = async () => {
  if (!deferredPrompt) {
    console.log('PWA installation not available');
    return false;
  }

  // Show the install prompt
  deferredPrompt.prompt();
  
  // Wait for the user to respond to the prompt
  const { outcome } = await deferredPrompt.userChoice;
  
  // We no longer need the prompt. Clear it for future use.
  deferredPrompt = null;
  
  return outcome === 'accepted';
};